<div id="activity" class="cursor-pointer activity-dropdown btn-header" (click)="onToggle()"
  title="{{'header_icon_cart' | i18n}}">
  <span>
    <a><span class="material-icons-outlined shpng_cart">
        local_grocery_store
      </span></a>
  </span>
  <b class="badge bg-color-red" id="cartCountShow" *ngIf="count!=0" style="height: 20px;width: 20px;">{{count}}</b>
</div>